function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (function (theme, _ref) {
  var getColor = _ref.getColor,
      getTextStyle = _ref.getTextStyle;

  function getContentColor(headerColor) {
    return headerColor === "grey.t07" ? "grey.t03" : headerColor === "secondary.lightBlue.t25" ? "secondary.lightBlue.t15" : "white";
  }

  return {
    getContentColor: getContentColor,
    getCSS: function getCSS(_ref2) {
      var targetElement = _ref2.targetElement,
          color = _ref2.color,
          textColor = _ref2.textColor,
          itemGap = _ref2.itemGap,
          isOpen = _ref2.isOpen,
          __internal__keyboardFocus = _ref2.__internal__keyboardFocus;

      switch (targetElement) {
        case "headerContainer":
          {
            return {
              margin: 0
            };
          }

        case "headerButton":
          {
            return _objectSpread(_objectSpread(_objectSpread(_objectSpread({
              display: "flex",
              alignItems: "center",
              width: "100%",
              border: 0,
              borderRadius: theme.radii[0],
              boxSizing: "border-box",
              padding: "".concat(theme.space[3], " ").concat(theme.space[4], " ").concat(theme.space[3], " ").concat(theme.space[6]),
              textAlign: "left"
            }, getTextStyle({
              name: "subtitle2",
              mode: "self-bold"
            })), {}, {
              outline: 0
            }, theme.focusStyles.focusVisible), __internal__keyboardFocus && theme.focusStyles.__keyboardFocus), {}, {
              backgroundColor: getColor(color),
              color: getColor(textColor)
            });
          }

        case "headerContent":
          {
            return {
              display: "flex",
              alignItems: "center",
              flexGrow: 1
            };
          }

        case "headerIcon":
          {
            return {
              display: "flex",
              marginRight: theme.space[2]
            };
          }

        case "headerChevron":
          {
            return _objectSpread({
              display: "flex",
              transformOrigin: "50% 50%",
              transition: "transform .25s ease"
            }, isOpen && {
              transform: "translateZ(0) rotate(180deg)"
            });
          }

        case "content":
          {
            return {
              textAlign: "left",
              backgroundColor: getColor(getContentColor(color)),
              padding: "".concat(theme.space[4], " ").concat(theme.space[11], " ").concat(theme.space[4], " ").concat(theme.space[6])
            };
          }

        case "item":
          {
            return {
              ":not(:first-of-type)": {
                marginTop: itemGap === "small" ? "1px" // This is an exception to our space scale
                : theme.space[1]
              }
            };
          }

        default:
          {
            return null;
          }
      }
    }
  };
});